import React, { memo } from 'react';
import { User } from '@app/models';
import { Info } from '@app/components';
import { useUserContext } from '@app/providers';
import { setMask, shotName } from '@app/helpers';

interface Props {
  author: User;
}

function IndividualUserInfo(props: Props) {
  const { author } = props;
  const { user } = useUserContext();
  return (
    <div className="section-author__info">
      <Info label="Автор" value={author ? shotName(author) : 'Не указано'} />
      {user.authenticated && (
        <>
          {author?.phone && (
            <Info
              label="Номер телефона"
              value={setMask(author.phone, '+7 (###) ### ## ##')}
            />
          )}
          {author?.email && (
            <Info label="Почтовый адрес" value={author.email} />
          )}
        </>
      )}
    </div>
  );
}

export default memo(IndividualUserInfo);
